import React from 'react'
import { motion } from "framer-motion";
import Heading from './Heading';
const Philosophy = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                duration: 0.8
            }
        }
    };
  return (
    <motion.section 
            className="main-lwbl bg-[#F9FAFB] py-16 px-[0.5rem] overflow-hidden h-[100%] "
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={containerVariants}
        >
             <Heading subHeading={'A Creative Philosophy Built on Light, Learning, and Encouragement'}  heading={'Learning Philosophy'}
             detail={'Our guiding value is that every artist deserves an environment where learning is supportive, constructive, and professionally valuable. We believe critique should not tear down, but illuminate possibilities and sharpen creative direction. Every educational resource is built to make artists feel confident, capable, and ready to showcase their uniqueness to the world.'}
             />
             <p className='text-xl font-normal mt-[1.5rem]'>
                “Inspiration is nothing without discipline. We teach both.”
             </p>
                </motion.section>
  )
}

export default Philosophy
